import React from "react";

const SubmitForm = () => {
  return (
    <div>
      <div class="col-12 form-group mg-t-8">
        <button
          type="submit"
          class="btn-fill-lg btn-gradient-yellow btn-hover-bluedark"
        >
          Save
        </button>
        <button type="reset" class="btn-fill-lg bg-blue-dark btn-hover-yellow">
          Reset
        </button>
      </div>
    </div>
  );
};

export default SubmitForm;
